export const GPU_SERVERS = [
  { id: 'HGX_H100_SXM8', name: 'NVIDIA HGX H100 SXM 8-GPU', image: 'H100_X_8_GPU', coolingPowerKW: 7.1, tsat: 43 },
  { id: 'HGX_H100_SXM4', name: 'NVIDIA HGX H100 SXM 4-GPU', image: 'H100_X_4_GPU', coolingPowerKW: 3.8, tsat: 43 },
  { id: 'HGX_H200_SXM8', name: 'NVIDIA HGX H200 SXM 8-GPU', image: 'H200_X_8_GPU', coolingPowerKW: 7.1, tsat: 48 },
  { id: 'HGX_B200_SXM8', name: 'NVIDIA HGX B200 SXM 8-GPU', image: 'B200_X8_GPU', coolingPowerKW: 9.7, tsat: 40 },
  { id: 'HGX_B300_SXM8', name: 'NVIDIA HGX B300 SXM 8-GPU', image: 'B300_X8_GPU', coolingPowerKW: 11, tsat: 40 },
  {
    id: 'MI300', name: 'AMD Instinct MI300', image: 'MI300_X8_GPU',
    subModels: [
      { id: 'MI300A', name: 'MI300A', coolingPowerKW: 6.8, tsat: 50 },
      { id: 'MI300X', name: 'MI300X', coolingPowerKW: 6.8, tsat: 50 },
      { id: 'MI325X', name: 'MI325X', coolingPowerKW: 6.8, tsat: 50 },
    ]
  },
];

function buildPlotData(data, HruType) {

  if ((HruType?.toLowerCase().includes('water')) || HruType?.toLowerCase() === 'eor' || HruType === '' || typeof HruType === 'undefined' || !HruType) {
    return plotWater(data, HruType);
  } else if (HruType.toLowerCase().includes('air')) {
    return plotAir(data);
  }

  return null; // Return null if no matching type found
}

function plotWater(data, hruType){
    var trace1 = {
        x: data.dataSeries["V_dot"],
        y: data.dataSeries["Tin"],
        type: 'scatter',
        mode: 'lines',
        name: 'Temperature In',
        showlegend: true,
        fill: 'tozeroy',
        fillcolor: 'rgba(60, 179, 229, 0.2)',
        line: {color: 'rgb(60, 179, 229)'},
        hovertemplate: "<b>Temperature In</b>: %{y:.1f}<extra></extra>"
      };

      var trace2 = {
        x: data.dataSeries["V_dot"],
        y: data.dataSeries["Tout_list"],
        type: 'scatter',
        mode: 'lines',
        name: 'Temperature Out',
        fill: 'tonexty',
        fillcolor: 'rgba(255, 0, 0, 0.3)',
        line: {color: 'red'},
        hovertemplate: "<b>Temperature Out</b>: %{y:.1f}<extra></extra>"
      };


      var trace3 = {
        x: data.dataSeries["V_dot"],
        y: data.dataSeries["P"],
        type: 'scatter',
        name: 'Pressure Drop',
        mode: 'lines',
        line: {color: 'black'},
        yaxis: 'y2',
        hovertemplate: "<b>Pressure Drop</b>: %{y:.1f}<extra></extra>"
      };

      var temperatureUnit = data.measurementSystem === 'Imperial' ? '[F]' : '[C]';
      var layout = {

          hovermode: 'x',
          xaxis: {
            title: data.measurementSystem === 'Imperial' ? 'Flow Rate [GPM]' : 'Flow Rate [m³/hour]',
            color: '#000000',
              hoverformat: '.1f'

          },
          yaxis: {
              title: 'Water Temperature '+ temperatureUnit,
              color: '#000000',
              side: 'left',
              range: [Math.min.apply(null, data.dataSeries['Tin']) - 5, Math.max.apply(null, data.dataSeries['Tout_list']) + 5]
          },
          yaxis2: {
              title:  data.measurementSystem === 'Imperial' ? 'Pressure Drop [psi]' : 'Pressure Drop [bar]',
              color: '#000000',
              overlaying: 'y',
              side: 'right',
              range: [0, data.maxP ]
          },
          legend: {
              x: 0.5,
              y: 1.2,
              orientation: 'h'
          },
          plot_bgcolor: '#FCFCFC',
          paper_bgcolor: '#FFFFFF'
      };


      var plotData = hruType === '' ||  typeof hruType === 'undefined' || !hruType ? [trace1, trace2] : [trace1, trace2, trace3];


      const plotDataObj = {plotData, layout}
      return plotDataObj

}

function plotAir(data){
var trace1 = {
    x: data.dataSeries["Tin"],
    y: data.dataSeries["Tout_list"],
    type: 'scatter',
    mode: 'lines',
    name: '$T_{in}$',
    line: {
        color: '#3CB3E5'
    },
    hovertemplate: "<b>Hot aisle</b>: %{y:.1f}<extra></extra>"

};

var temperatureUnit = data.measurementSystem === 'Imperial' ? '[F]' : '[C]';

var layout = {

    hovermode: 'x',
    plot_bgcolor: '#FFFFFF',
    paper_bgcolor: '#FFFFFF',
    xaxis: {
        title: 'Cold Aisle Temperature ' + temperatureUnit,
        color: 'rgb(1, 180, 220)',
        tickfont: {
            color: '#000000'
        },
        hoverformat: '.1f'

    },
    yaxis: {
        title: 'Hot Aisle Temperature ' + temperatureUnit,
        color: '#FF0000',
        tickfont: {
            color: '#000000'
        }
    },
    legend: {
        x: 0.5,
        y: 1.2,
        orientation: 'h'
    }
};

    var plotData = [trace1];


    const plotDataObj = {plotData, layout}
    return plotDataObj

}


export default buildPlotData;
